<me-toast position="bottom-center" [preventOpenDuplicates]="true"></me-toast>

<router-outlet></router-outlet>

<p-confirmDialog [style]="{ width: '400px' }"></p-confirmDialog>

<p-confirmDialog
  key="critical"
  styleClass="critical-confirm-dialog"
  [style]="{ width: '400px' }"
></p-confirmDialog>

<p-confirmDialog
  key="normal"
  styleClass="normal-confirm-dialog"
  [style]="{ width: '400px' }"
></p-confirmDialog>

<p-confirmDialog
  key="warning"
  styleClass="warning-confirm-dialog"
  [style]="{ width: '400px' }"
></p-confirmDialog>

<p-confirmDialog
  key="wide-normal"
  styleClass="normal-confirm-dialog"
  [style]="{ width: '572px' }"
></p-confirmDialog>
